import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import MasterDataDataGroupButton from '../../../components/MasterData/MasterDataDataGroupButton';
import DataScopeEdit from '../DataScope/Edit';
import MasterDataAuditDetail from '../../../components/MasterData/MasterDataAuditDetail';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_DATA_GROUP_UPDATE } from '../../../constants/menuPermissionConstant';

class DataGroupEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataGroupId: '',
            dataGroupDescription: '',
            dataGroupScope: [],
            dataGroupLevel: {
                data: [
                    {
                        value: 'super_admin',
                        label: 'super_admin'
                    },
                    {
                        value: 'nexsoft',
                        label: 'nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'distributor'
                    },
                    {
                        value: 'principal',
                        label: 'principal'
                    },
                    {
                        value: 'cso',
                        label: 'cso'
                    },
                ],
                selected: ''
            },
            dataScopePage: false,
            dataGroupDetail: {},
            createdAt: '',
            updatedAt: '',
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getDetailDataGroup = () => {
        API_MASTER_DATA.getDetailDataGroup(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let scopeData = getContent(res).scope
                    let scopeResult = []
                    for (let scopeName in scopeData) {
                        for (const scopeId of scopeData[scopeName]) {
                            scopeResult.push(scopeName + ":" + scopeId)
                        }
                    }

                    this.setState({
                        dataGroupDetail: getContent(res),
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                        dataGroupId: getContent(res).group_id,
                        dataGroupDescription: getContent(res).description,
                        dataGroupScope: scopeResult,
                        dataGroupLevel: {
                            ...this.state.dataGroupLevel,
                            selected: getContent(res).level
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeDataGroupCategory = data => {
        this.setState({
            dataGroupLevel: {
                ...this.state.dataGroupLevel,
                selected: data.value
            }
        })
    }

    handleDataGroup = () => {
        this.setState({
            dataScopePage: false
        })
    }

    handleDataScope = () => {
        this.setState({
            dataScopePage: true
        })
    }

    handleChangeDataScope = (dataCustomer, dataPrincipal) => {
        this.setState({
            dataGroupScope: [...dataCustomer, ...dataPrincipal]
        })
    }

    handleSubmit = () => {
        let includeCustomer = false;
        let includePrincipal = false;

        if (this.state.dataGroupScope.length > 0) {
            this.state.dataGroupScope.forEach((data, index) => {
                let dataScope = data.split(':')
                if (dataScope[0] === 'nexsoft.user_customer.cust') {
                    includeCustomer = true;
                }
                if (dataScope[0] === 'nexsoft.user_customer.pr') {
                    includePrincipal = true;
                }
            })
        }

        if (includeCustomer && includePrincipal) {
            const data = {
                group_id: this.state.dataGroupId,
                description: this.state.dataGroupDescription,
                scope: this.state.dataGroupScope,
                updated_at: this.state.dataGroupDetail.updated_at
            }

            API_MASTER_DATA.putDataDataGroup(this.state.dataGroupDetail.id, data, this.props.token)
                .then(res => {
                    this.setState({
                        showSuccessAlert: true,
                    })
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false })
                        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)
                    }, 1500)
                }).catch(err => {
                    this.setState({
                        errorMessage: getErrorMessage(err),
                        showErrorAlertResponse: true
                    })
                    if (err.response?.status === 401) {
                        this.props.history.push(ROUTER_CONSTANT.LOGIN);
                        this.props.handleLogout();
                    }
                })

            return;
        }

        this.setState({ showErrorAlert: true })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailDataGroup();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_UPDATE]} userPermission={this.props.userDetail.permissions}>
                <div className="data-group-container">
                    <div className={this.state.dataScopePage ? "block" : "hidden"}>
                        {
                            Object.keys(this.state.dataGroupDetail).length > 0 &&
                            <DataScopeEdit
                                data={this.state.dataGroupDetail}
                                dataScopePage={this.state.dataScopePage}
                                handleDataGroup={this.handleDataGroup}
                                handleDataScope={this.handleDataScope}
                                handleChangeDataScope={this.handleChangeDataScope}
                                handleSubmit={this.handleSubmit}
                            />
                        }
                    </div>
                    <div className={!this.state.dataScopePage ? "block" : "hidden"}>
                        <MasterDataDataGroupButton
                            dataScopePage={this.state.dataScopePage}
                            handleDataGroup={this.handleDataGroup}
                            handleDataScope={this.handleDataScope}
                        />
                        <WhiteContainer>
                            <div className="flex">
                                <div className="w-1/2 p-10 kiri">
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium" htmlFor="tsldatagroupid">Group ID</label>
                                        </div>
                                        <div className="w-5/6">
                                            <input
                                                type="text"
                                                id="tsldatagroupid"
                                                name="dataGroupId"
                                                className="form-control"
                                                placeholder="Tulis Group ID"
                                                autoComplete="off"
                                                defaultValue={this.state.dataGroupDetail.group_id}
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium" htmlFor="tmldatagroupdescription">Deskripsi</label>
                                        </div>
                                        <div className="w-5/6">
                                            <textarea
                                                id="tmldatagroupdescription"
                                                name="dataGroupDescription"
                                                className="form-control resize-none h-48 2xl:h-40"
                                                placeholder="Tulis Deskripsi"
                                                defaultValue={this.state.dataGroupDetail.description}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <MasterDataAuditDetail
                                    createdAt={this.state.createdAt}
                                    updatedAt={this.state.updatedAt}
                                    modifiedBy={this.state.dataGroupDetail.modified_by}
                                />
                            </div>
                            <div className="absolute bottom-5 right-5">
                                <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)}>Batal</button>
                                <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleSubmit()}>Simpan</button>
                            </div>
                        </WhiteContainer>
                    </div>
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Mengubah Data Group!" />
                    <Alert show={this.state.showErrorAlert} icon="warning" title="Data Scope Distributor dan Principal tidak boleh kosong!" close={() => this.setState({ showErrorAlert: false })} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataGroupEdit));